import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { WintSuperkollAPIModel, WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { ChartContainerDataSet } from "models/propTypes/chartProps";
import { ChartEnums, CurrencyEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ChartContainer, MultiLineChartTitle } from "components/common";
import { useQuotesService } from "serviceHooks";
//#endregion
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const QuotesTotalByStatusChart: React.FC = () => {
  const quotesService = useQuotesService();
  const formatData = (chartData?: ApiModels.ReportWidget): ChartContainerDataSet[] => {
    const data = chartData?.data;

    const result = EnumHelper.getNumericItemValues(ApiModels.QuotationApiState).map(
      (i): ChartContainerDataSet => ({
        label: LocalizationHelperInstance.getFormattedMessage(`Invoice.QuotesWidgetState_${i}`),
        data:
          data
            ?.filter((d) => Number(d.name) === i)
            ?.map((i) => (i.dataPoints ? i.dataPoints[0] : 0))
            .reduce((prev: number, current: number, index, arr: number[]) => prev + current, 0) ?? 0,
        isNotSelected: i === ApiModels.QuotationApiState.NotSent,
      })
    );
    return result;
  };

  const getChartTitle = (chartData?: ApiModels.ReportWidget) => {
    const data = chartData?.data;

    return (
      <MultiLineChartTitle
        rows={[
          {
            title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.UnpaidInvoices),
            value: LocalizationHelperInstance.getFormattedCurrency(
              data
                ?.map((i) => (i.dataPoints ? i.dataPoints[0] : 0))
                .reduce((prev: number, current: number, index, arr: number[]) => prev + current, 0) ?? 0,
              CurrencyEnums.CurrencyCode.SEK
            ),
          },
        ]}
      />
    );
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.QuotesStatusDistribution}
      apiToChartHandler={formatData}
      filterToAPIHandler={quotesService.reportToAPIFilter}
      chartTitle={getChartTitle}
      doughnutChartLegendType={ChartEnums.LegendType.WITH_VALUES}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.STATUS}
      usePageFilter={false}
      useClickableChart
      onDataPointClickedSetFilter={(label?: any) => {
        const clickedLabel = typeof label === "string" ? label : undefined;
        const matchedState = EnumHelper.getNumericItemValues(ApiModels.QuotationApiState).find((i) => {
          const localized = LocalizationHelperInstance.getFormattedMessage(`Invoice.QuotesWidgetState_${i}`);
          return localized === clickedLabel;
        }) as ApiModels.QuotationApiState | undefined;

        return matchedState !== undefined && matchedState >= 0
          ? {
              states: [
                {
                  id: matchedState,
                  value: quotesService.getStateText(matchedState),
                },
              ],
            }
          : {};
      }}
      onBackgroundClickedSetFilter={{ states: undefined }}
    />
  );
};

export default QuotesTotalByStatusChart;
